import React, { useState, useEffect, useRef, useCallback } from 'react';
import { API } from '../utils/api';

const CHECK_INTERVAL = 300000; // Check every 5 minutes (was 60s — too aggressive for production)

const VersionChecker = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const initialVersionRef = useRef(null);

  const checkVersion = useCallback(async () => {
    try {
      const res = await fetch(`${API}/version`);
      if (res.ok) {
        const data = await res.json();
        if (!initialVersionRef.current) {
          initialVersionRef.current = data.version;
        } else if (data.version !== initialVersionRef.current) {
          setUpdateAvailable(true);
        }
      }
    } catch (e) { /* silent */ }
  }, []);

  useEffect(() => {
    checkVersion();
    const interval = setInterval(checkVersion, CHECK_INTERVAL);
    return () => clearInterval(interval);
  }, [checkVersion]);

  const handleRefresh = () => {
    if ('caches' in window) {
      caches.keys().then(names => Promise.all(names.map(n => caches.delete(n))));
    }
    if (navigator.serviceWorker) {
      navigator.serviceWorker.getRegistrations().then(regs =>
        regs.forEach(r => r.update())
      );
    }
    setTimeout(() => window.location.reload(true), 300);
  };

  if (!updateAvailable) return null;

  return (
    <div
      data-testid="version-update-banner"
      style={{
        position: 'fixed', bottom: 20, left: '50%', transform: 'translateX(-50%)',
        zIndex: 10000, background: 'linear-gradient(135deg, #1e40af, #FCD34D)',
        color: '#0F172A', padding: '12px 24px', borderRadius: 12,
        boxShadow: '0 8px 32px rgba(0,0,0,0.3)', display: 'flex',
        alignItems: 'center', gap: 16, fontSize: 14, fontWeight: 500,
        backdropFilter: 'blur(8px)', border: '1px solid rgba(255,255,255,0.15)'
      }}
    >
      <span>A new version is available</span>
      <button
        data-testid="version-refresh-btn"
        onClick={handleRefresh}
        style={{
          background: '#fff', color: '#1e40af', border: 'none',
          padding: '6px 16px', borderRadius: 8, cursor: 'pointer',
          fontWeight: 600, fontSize: 13
        }}
      >
        Refresh Now
      </button>
      <button
        onClick={() => setUpdateAvailable(false)}
        style={{
          background: 'transparent', color: '#0F172A', border: '1px solid rgba(255,255,255,0.3)',
          padding: '6px 12px', borderRadius: 8, cursor: 'pointer', fontSize: 13
        }}
      >
        Later
      </button>
    </div>
  );
};

export default VersionChecker;
